<template>
    <div class="questions-map-container map-dashboard">
        <pageLoader :showLoader="showPageLoader" :checkDocState=false></pageLoader>
        <l-map
            ref="myMap" @ready="onMapReady()" class="map" :zoom="mapData.zoom" :center="mapData.center"
            v-on:update:zoom="updateZoom($event)"
        >
            <l-tile-layer :url="mapData.tilesUrl" :attribution="''"></l-tile-layer>
            <v-marker-cluster ref="clusterRef" :options="mapData.clusterOptions" @clusterclick="onClusterClick">
                <l-marker v-for="c in items" :lat-lng="c.latlng" :options="{q_id: c.q_id, has_i: c.has_i, t: c.t}" :icon="prepareMarkerIcon(c)" v-if="!historyView.showHistory"
                @click="onMarkerClick(c, $event)">
                    <l-popup ref="popup" class="marker_popup">
                        <div v-if="c.t != 0" style="margin-bottom: 4px;">{{c.tn}}</div>
                        <div>Updated on {{(c.date*1000) | moment("MMM D YYYY, h:mm a")}}{{c.s != '' ? ` by ${c.s}` : ''}}</div>
                        <div class="marker_popup_btns">
                            <div class="history_btn" @click="onShowHistoryClick(c)" v-if="c.h">Show history</div><span v-if="c.h">&nbsp;|&nbsp;</span>
                            <div class="copy_link_btn" @click="onCopyLinkClick(c)">Copy link</div><span>&nbsp;|&nbsp;</span>
                            <div class="copy_link_btn" @click="onOpenInGoogleClick(c)">open in Google</div>
                        </div>
                        <div class="marker_popup_btns">
                            <div class="fix_issue_btn" @click="onFixLocationIssueClick(c)" v-if="c.has_i">fix location problem</div>
                        </div>
                    </l-popup>
                </l-marker>
            </v-marker-cluster>
            <v-marker-cluster ref="clusterRef" :options="mapData.historyItemClusterOptions" @clusterclick="">
                <l-marker v-for="c in historyView.historyItems" :lat-lng="c.latlng" :options="{q_id: c.q_id, i: c.i, t: c.t}" :icon="prepareHistoryMarkerIcon(c)" v-if="historyView.showHistory">
                    <l-popup ref="popup" class="marker_popup">
                        <div>Updated on {{(c.started_at*1000) | moment("MMM D YYYY, h:mm a")}}{{c.s != '' ? ` by ${c.s}` : ''}}</div>
                        <div class="marker_popup_btns">
                            <div class="copy_link_btn" @click="onOpenInGoogleClick(c)">open in Google</div><span>&nbsp;|&nbsp;</span>
                            <div class="close_history_btn" @click="onCancelLocationHistoryClick">exit history view</div>
                        </div>
                        <div class="marker_popup_btns">
                            <div class="fix_issue_btn" @click="onFixLocationIssueClick(c)" v-if="c.i && !c.i.fixed">fix location problem</div>
                        </div>
                    </l-popup>
                </l-marker>
            </v-marker-cluster>
<!--            <l-polyline
                :lat-lngs="historyView.historyLatLngs"
                :options="historyPolylineOptions"
            />-->
            <l-marker :lat-lng="myLocation"  :icon="prepareMyLocMarkerIcon()" v-if="myLocation.lat && myLocation.lng"/>
        </l-map>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="range">
            <div class="search_wrapper">
                <div class="searchfield_wrapper">
                            <md-autocomplete
                                :md-options="autocompleteAddressCollection"
                                @md-changed="onSearchAddressChanged"
                                @md-selected="onSearchAddressSelect"
                                class="autocomplete"
                                :md-input-placeholder="searchType == 'address' ? 'Search address' : 'Filter by asset number'"
                                v-model="searchAddressQuery">
                                <template class="addressDropdownItem" slot="md-autocomplete-item"
                                          slot-scope="{ item }">
                                    <div v-if="item.isAddress">
                                        <md-highlight-text>{{ item.main_text }}</md-highlight-text>
                                        <md-highlight-text>{{ item.secondary_text }}</md-highlight-text>
                                    </div>
                                    <div v-else>
                                    </div>
                                </template>
                            </md-autocomplete>
                    <div class="search_search_btn" v-if="showAssetsSearchBtn" @click="onSearchByAssetClick">Search</div>
                    <div class="search_clear_btn" v-if="searchAddressQuery != ''" @click="onClearSearchClick"><img src="@/assets/icons/ic_clear.svg"></div>
                </div>
                <div class="search_type_selector">
                    <span v-if="searchType == 'asset_id'" @click="onSearchTypeSelected('address')">or search for <span class="search_type_item">Address</span></span>
                    <span v-if="searchType == 'address'" @click="onSearchTypeSelected('asset_id')">or filter by <span class="search_type_item">Asset number</span></span>
                </div>
            </div>
            <div class="history_mode_wrapper" v-if="historyView.showHistory">
                <div>
                    Displaying location history for "{{historyView.item.assetId == '' ? '<>' : historyView.item.assetId}}". <span class="history-cancel" @click="onCancelLocationHistoryClick">Cancel</span>
                </div>
            </div>
        </div>
        <div @click="onRefreshClick" class="refresh-btn">{{ translate('airLeadDashboardRefresh') }}</div>
        <div class="my_loc_btn" @click="onMyGeolocationClick"><img src="@/assets/icons/mylocation_button.svg"></div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import customModalDialog from '@/components/widgets/customModalDialog';
import moment from 'moment'
import errorMixin from '@/mixins/errorMixin';
import CONSTANTS from '@/store/modules/serviceLog'
import datePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import customModalMapDashboard from '@/components/widgets/customModalMapDashboard';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import MarkerClusterer from 'marker-clusterer-plus'
import PlaceMarkerInfoModal from '@/components/widgets/placeMarkerInfoModal'
import L, {Icon} from 'leaflet';
import {LMap, LMarker, LTileLayer, LPolyline, LPopup} from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet/dist/leaflet.css';
import logAnalyticsEvent, {logPageView} from "@/helpers/analytics";
import mapMixin from "@/mixins/mapMixin";
import geoLocationMixin from "@/mixins/geoLocationMixin";
import pageLoader from "@/components/widgets/pageLoader";
import img from "@/assets/icons/ic_marker_asset_blue.png";
import config from "@/api/config";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: 'QuestionsMap',
    mixins: [mixin, errorMixin, mapMixin, geoLocationMixin],
    components: {
        InfiniteLoading,
        customModalDialog,
        datePicker,
        customModalMapDashboard,
        PlaceMarkerInfoModal,
        'gmap-custom-marker': GmapCustomMarker,
        MarkerClusterer,
        LMap,
        LTileLayer,
        LMarker,
        LPolyline,
        LPopup,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
        pageLoader,
    },
    data() {
        return {
            showPageLoader: false,
            myLocation: {
                lat: null,
                lng: null,
                accuracy: 0,
            },
            CONSTANTS: CONSTANTS,
            customModalSettings: {},
            customModalMapDashboard: {
                show: false,
            },
            zoom: 6,
            mapData: {
                tilesUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                zoom: 3,
                center: [41.794461, -101.674352],
                clusterOptions: {
                    iconCreateFunction: this.createClusterHtml,
                    showCoverageOnHover: false,
                    spiderfyOnMaxZoom: true,
                    // disableClusteringAtZoom: 17,
                    spiderfyDistanceMultiplier: 2,
                },
                historyItemClusterOptions: {
                    iconCreateFunction: this.createHistoryClusterHtml,
                    showCoverageOnHover: false,
                    spiderfyOnMaxZoom: true,
                    // disableClusteringAtZoom: 17,
                    spiderfyDistanceMultiplier: 4,
                },
                showLegend: false,
            },
            styles: [
                {
                    width: 50,
                    height: 50,
                    rate: {h: 0, g: 0, s: 0},
                    url: `http://localhost:8080/admin/pie?happy=1&soso=1&sad=1`,
                    textColor: "#ff00ff",
                    textSize: 10,
                }
            ],
            cases: [
                {options: {kek: 1}, latlng: {lat: 47, lng: 32}},
                {options: {kek: 2}, latlng: {lat: 47.01, lng: 32.02}},
                {options: {kek: 3}, latlng: {lat: 47.02, lng: 32.02}},
                {options: {kek: 4}, latlng: {lat: 47.01, lng: 32.03}},
                {options: {kek: 5}, latlng: {lat: 47.03, lng: 32.12}}
            ],
            originalItems: [],
            items: [],
            historyView: {
                item: {
                    assetId: 'STD-1245',
                    questionId: 0,
                },
                historyItems: [],
                historyLatLngs: [],
                showHistory: false,
            },
            historyPolyline: null,
            historyPolylineOptions: {
                color: '#2D59A2',
                weight: 2,
                opacity: 1.0,
            },
            autocompleteAddressCollection: [],
            searchAddressQuery: '',
            showAssetsSearchBtn: false,
            searchType: 'address',
            cache: {
                clusters: new Map(),
                markers: new Map(),
            },
        }
    },
    computed: {
        ...mapState({
            accounts: state => state.closeAccount.accounts,
            userInfo: state => state.auth.userInfo,
        })
    },
    mounted() {
        this.refreshAll()

        this.startWatchingGps((location)=>{ //todo clear watcher later???
            this.myLocation = location
        }, (error)=>{
            if(error instanceof GeolocationPositionError) {
                console.log(`kek type = GeolocationPositionError`)
                if(e.code == e.PERMISSION_DENIED) {
                    this.allowGpsRequestPopupSettings = {
                        show: true,
                        onOkHandler: () => {
                            console.log('permission');
                        },
                    }
                } else {
                    this.gpsErrorPopupSettings = {
                        show: true,
                        subtitle: e.code == e.TIMEOUT ? 'We were unable to fetch gps location. Please try again' : 'GPS location is unavailable. Please try again or contact our support team' //todo strings
                    }
                }
            }
            //todo ignore ?
        })
    },
    methods: {
        ...mapGetters({}),
        ...mapActions({
            getQuestionsMap: 'question/getQuestionsMap',
            getQuestionsLocationHistory: 'question/getQuestionsLocationHistory',
            fixLocationIssueForQuestion: 'question/fixLocationIssueForQuestion',
            logUnauthorizedLocationIssueFix: 'question/logUnauthorizedLocationIssueFix',
            searchAddressAutocomplete: 'search/searchAddressAutocomplete',
            geocodeGooglePlaceId: 'search/geocodeGooglePlaceId',
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
            setProgressBarTag: 'setProgressBarTag',
        }),

        onRefreshClick(){
            // this.$refs.clusterRef.mapObject.refreshClusters()
            this.refreshAll()
        },
        reclusterItems() {
            this.$refs.clusterRef.mapObject.refreshClusters()
        },
        updateZoom: function(e) {
            this.mapData.zoom = e;
        },
        async refreshAll() {
            //todo?
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'load map data'
                })
                this.loadingAction = true
                let start = (new Date()).getTime()
                console.log(`DDDDD before get report`)
                let hash = this.$route.params.hash
                const response = await this.getQuestionsMap({hash: hash})
                let afterGetReport = (new Date()).getTime()
                console.log(`DDDDD after get report: ` + (afterGetReport - start))
                this.items = []
                let afterSplice = (new Date()).getTime()
                console.log(`DDDDD after splice: ` + (afterSplice - afterGetReport))
                // let items = response.clusters
                let items = response.items
                this.originalItems = items
                var bounds = L.latLngBounds()
                let selectedItemId = this.$route.query.q_id
                items.forEach((item) => {
                    this.items.push(item)
                    if(!selectedItemId || item.q_id == selectedItemId) {
                        bounds.extend(item.latlng)
                    }
                })
                this.fitMapToBounds(bounds, [50, 50])
                let afterForeach = (new Date()).getTime()
                console.log(`DDDDD after foreach: ` + (afterForeach - afterSplice))
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'load map data'
                })
            }
        },


        async fetchLocationHistory(questionId, assetId) {
            //todo?
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'load details'
                })
                this.loadingAction = true
                let hash = this.$route.params.hash
                const response = await this.getQuestionsLocationHistory({hash: hash, qId: questionId})
                let items = response.items
                let historyItemsCount = items.length
                // this.historyView.historyItems.splice(0, this.historyView.historyItems.length);
                // this.historyView.historyLatLngs.splice(0, this.historyView.historyLatLngs.length);
                this.historyView.historyItems = []
                this.historyView.historyLatLngs = []
                if(historyItemsCount > 1) {
                    var bounds = L.latLngBounds()
                    items.forEach((item) => {
                        this.historyView.historyItems.push(item)
                        this.historyView.historyLatLngs.push(item.latlng)
                        bounds.extend(item.latlng)
                    })
                    var imgData = this.getMarkerImageData(items[0], false)
                    this.historyPolylineOptions.color = imgData.color
                    var polyline = L.polyline(this.historyView.historyLatLngs).addTo(this.$refs.myMap.mapObject);
                    polyline.setStyle(this.historyPolylineOptions);
                    this.removePolyline()
                    this.historyPolyline = polyline
                    this.historyView.showHistory = true
                    this.historyView.item.assetId = response.asset_id
                    this.historyView.item.questionId = response.question_id
                    this.fitMapToBounds(bounds, [80, 80])
                } else {
                    let name = assetId == '' || assetId == '<>' ? 'This asset' : `Asset "${assetId}"`
                    this.showErrorModal(`${name} doesn't have elder locations`, {duration: 2200})
                }
            } catch (e) {
                console.log(e)
                this.historyView.showHistory = false
                this.removePolyline()
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'load details'
                })
            }
        },

        removePolyline() {
            if(this.historyPolyline) {
                this.historyPolyline.remove()
            }
        },

        onCancelLocationHistoryClick() {
            this.showLoader(true)
            this.historyView.showHistory = false
            this.historyView.historyItems = []
            this.historyView.historyLatLngs = []
            this.removePolyline()
            // var bounds = L.latLngBounds()
            // this.items.forEach((item) => {
            //     bounds.extend(item.latlng)
            // })
            // this.fitMapToBounds(bounds)
            this.showLoader(false)
        },

        fitMapToBounds(bounds, padding = [50, 50]) {
                this.$refs.myMap.mapObject.fitBounds(bounds, {padding: padding})
            // setTimeout(() => {
            // }, 10);
        },

        showLoader(show) {
            this.showPageLoader = show
        },

        getMarkerIcon(item) {
            if (item.rate.h > item.rate.g && item.rate.h > item.rate.s) {
                return require('@/assets/re/marker_green.png')
            } else if (item.rate.g > item.rate.h && item.rate.g > item.rate.s) {
                return require('@/assets/re/marker_yellow.png')
            } else {
                return require('@/assets/re/marker_red.png')
            }
        },

        onMarkerClick(item, event) {
            // console.log(`onMarkerClick: event:${event}`, JSON.stringify(item))
            console.log(`onMarkerClick: event:`, event)
        },
        onShowHistoryClick(item) {
            this.fetchLocationHistory(item.q_id, item.a_id)
        },
        async onCopyLinkClick(item) {
            try {
                await this.copyContent(`${window.location.origin}/places/${this.$route.params.hash}/map/?q_id=${item.q_id}`, '')
                this.showErrorModal(`Copied`, {duration: 800})
            } catch (e) {
                this.showErrorModal(`Unable to copy :(`, {duration: 1500})
            }
        },
        async onOpenInGoogleClick(item) {
            window.open(`https://www.google.com/maps/place/${item.latlng.lat},${item.latlng.lng}/@${item.latlng.lat},${item.latlng.lng},17z`, '_blank').focus();
        },

        async onFixLocationIssueClick(item) {
            this.customModalSettings = {
                icon: 'ic_gps_broblem.svg',
                title: '',
                message: 'This will confirm that the problem is fixed',
                okButtonText: 'Continue',
                onOkHandler: () => {
                    this.fixLocationIssue(item)
                },
                showCancelButton: true,
                cancelButtonText: this.translate('Cancel'),
            }
        },

        async fixLocationIssue(item) {
            let hash = this.$route.params.hash
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'fix issue'
                })
                this.loadingAction = true
                const response = await this.fixLocationIssueForQuestion({hash: hash, qId: item.q_id})
                item.has_i = false


                var index = this.items.findIndex(item_ => item_.q_id === item.q_id)
                console.log(`this.items index: ${index}`)
                if (index > -1) {
                    let item = this.items.splice(index, 1)[0];
                    item.has_i = false
                    this.items.push(item)
                }
                index = this.originalItems.findIndex(item_ => item_.q_id === item.q_id)
                console.log(`this.originalItems index: ${index}`)
                if (index > -1) {
                    let item = this.originalItems.splice(index, 1)[0];
                    item.has_i = false
                    this.originalItems.push(item)
                }
                index = this.historyView.historyItems.indexOf(item);
                console.log(`this.historyView.historyItems index: ${index}`)
                if (index > -1) {
                    let item = this.historyView.historyItems.splice(index, 1)[0];
                    item.i.fixed = true
                    this.historyView.historyItems.push(item)
                }

                this.reclusterItems()

            } catch (e) {
                console.log(e)
                if(e.data.error.code == 1013) {
                    this.showErrorModal("Please login to the system to perform this action", {
                        title: 'Not enough rights',
                        code: e.data.error.code
                    })
                } else {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                    try {
                        const response = await this.logUnauthorizedLocationIssueFix({hash: hash, qId: item.q_id})
                    } catch (e){}
                }
            } finally {
                this.loadingAction = false
                this.setProgressBarTag({
                    show: false,
                    tag: 'fix issue'
                })
            }
        },

        onMarkerMouseClick(item) {
            console.log(`onMarkerMouseClick: `, JSON.stringify(this.items))
        },
        onMapClick(event) {
            console.log(`onMapClick: ${event.latLng.lat()} ${event.latLng.lng()}`)

            let maxVotes = this.getRandomVotesCount(500)
            let item = {
                location: {lat: event.latLng.lat(), lng: event.latLng.lng()},
                rate: {
                    h: this.getRandomVotesCount(maxVotes),
                    g: this.getRandomVotesCount(maxVotes),
                    s: this.getRandomVotesCount(maxVotes)
                },
                info: {name: `#${this.items.length}`}
            }
            this.items.push(item)
        },
        getRandomVotesCount(max) {
            return Math.floor(Math.random() * Math.floor(max));
        },

        calculatorFunc(markers, numStyles) {
            console.log(`test_calculatorFunc numStyles:${numStyles} markers:`, markers)
            var rate = {h: 0, g: 0, s: 0}
            for (let i = 0; i < markers.length; i++) {
                console.log(`marker:`, markers[i].info)
            }
            for (var markerIndex in markers) {
                // console.log(`marker:`, markerIndex)
                let marker = this.items[markerIndex]
                rate.h += marker.rate.h
                rate.g += marker.rate.g
                rate.s += marker.rate.s
            }
            var styleIndex = -1;
            for (var i = 0; i < this.styles.length; i++) {
                if (this.styles[i].rate.h === rate.h
                    && this.styles[i].rate.g === rate.g
                    && this.styles[i].rate.s === rate.s) {
                    styleIndex = i
                }
            }
            if (styleIndex === -1) {
                this.styles.push({
                    width: 100,
                    height: 100,
                    rate: rate,
                    url: this.getChartUrl(rate),
                    textColor: "#ff00ff",
                })
                styleIndex = this.styles.length - 1
            }
            // console.log(`styleIndex: ${styleIndex} length: ${this.styles.length} styles:`, this.styles)
            return {
                text: "",
                index: styleIndex
            };
        },

        getChartUrl(rate) {
            // return `http://localhost:8080/admin/cropImage?happy=${rate.h}&soso=${rate.g}&sad=${rate.s}`
            return `https://devapi.air-vote.com/admin/pie2?happy=${rate.h}&soso=${rate.g}&sad=${rate.s}&size=100`
            // return `http://localhost:8080/admin/cropImage?w=60&h=60&x=145&y=0&image_url=https%3A%2F%2Fimage-charts.com%2Fchart%3Fchco%3D228e00%2Cff9d00%2Cb51700%26chd%3Dt%3A${rate.h}%2C${rate.g}%2C${rate.s}%26chf%3Dbg%2Cs%2Cffffff00%26chof%3D.png%26chs%3D350x60%26cht%3Dp3%26chl%3D${rate.h}%7C${rate.g}%7C${rate.s}%26chlps%3Dfont.size%2C8%7Ccolor%2CFFFFFF`
        },

        onMapReady() {
            console.log(`map ready!`)
        },
        getMarkerImageData(c, hasIssue) {
            var imgName = 'ic_qmarker_generic_lbl'
            let color = '#045451'
            switch (c.t) {
                case 1: {
                    imgName = 'ic_qmarker_asset_lbl'
                    color = '#2d5a9e'
                    break
                }
                case 2: {
                    imgName = 'ic_qmarker_trailer_lbl'
                    color = '#00677a'
                    break
                }
                case 4: {
                    imgName = 'ic_qmarker_greasetrap_lbl'
                    color = '#000000'
                    break
                }
                case 5: { //interceptor
                    imgName = 'ic_qmarker_greasetrap_lbl'
                    color = '#000000'
                    break
                }
                case 6: {
                    imgName = 'ic_qmarker_dumpster_lbl'
                    color = '#4a9e34'
                    break
                }
                case 7: {
                    imgName = 'ic_qmarker_handwash_lbl'
                    color = '#937902'
                    break
                }
                case 8: {
                    imgName = 'ic_qmarker_tank_lbl'
                    color = '#00065a'
                    break
                }
                default: {

                }
            }
            if(hasIssue) {
                imgName += '_issue'
            }
            return {imgName: imgName, color: color}
        },
        prepareMarkerIcon(c) {
            let hasIssue = c.has_i
            let cacheName = `${this.getHasIssueTagString(hasIssue)}_${c.a_id}_${c.t}`
            var icon = this.cache.markers.get(cacheName)
            if(icon != null) {
                // console.log(`prepareMarkerIcon use cached`)
                return icon
            }
            // console.log(`prepareMarkerIcon create new`)
            var imgData = this.getMarkerImageData(c, hasIssue)
            let img = require(`@/assets/icons/${imgData.imgName}.png`)
            icon = L.divIcon({ html: `
<div class="asset_marker_wrapper">
<img class="asset_marker_img" src="${img}"/>
<div class="asset_marker_lbl" style="border-color: ${imgData.color};">${c.a_id}</div>
</div>
`, iconAnchor: [17.5, 65], popupAnchor: [0, -80],});
            this.cache.markers.set(cacheName, icon)
            return icon
        },
        prepareHistoryMarkerIcon(c) {
            let issue = c.i
            let hasActiveIssue = issue != null && issue.fixed == false
            console.log(`prepareHistoryMarkerIcon`, c)
            var imgData = this.getMarkerImageData(c, hasActiveIssue)
            let img = require(`@/assets/icons/${imgData.imgName}.png`)
            let backgroundColor = c.finished_at == null ? imgData.color : 'white'
            return L.divIcon({ html: `
<div class="asset_marker_wrapper">
<img class="asset_marker_img" src="${img}"/>
<div class="asset_marker_lbl ${c.finished_at == null ? 'current' : ''}"  style="border-color: ${imgData.color}; background-color: ${backgroundColor};">${moment(c.started_at*1000).format("MMM D YYYY, h:mm a")}</div>
</div>
`, iconAnchor: [17.5, 47], popupAnchor: [0, -65],});
        },
        prepareMyLocMarkerIcon() {
            console.log(`prepareMyLocMarkerIcon`)
            return L.divIcon({ html: `
<div class="asset_marker_wrapper my_loc">
<img class="asset_marker_img" src="${require('@/assets/icons/ic_marker_my_loc.png')}"/>
<div class="asset_marker_lbl">You are here</div>
</div>
`, iconAnchor: [17.5, 65],});
        },
        onClusterClick(kek) {
            console.log(`on cluster click:`, kek)
        },
        getHasIssueTagString(hasIssue) {
          if(hasIssue) {
              return "!"
          } else {
              return ""
          }
        },
        getClusterImageName(cluster, hasIssue, types) {
            // console.log(`getClusterImageName: types:`, types)
            let color = '#045451'
            var imgName = 'ic_qmarker_generic_cluster'
            if(types.size == 1 && types.has(1)) {
                imgName = 'ic_qmarker_asset_cluster'
                color = '#2d5a9e'
            } else if(types.size == 1 && types.has(2)) { //only trailer
                imgName = 'ic_qmarker_trailer_cluster'
                color = '#00677a'
            } else if(types.size == 1 && (types.has(4) || types.has(5))) { //only greasetrap or interceptor
                imgName = 'ic_qmarker_greasetrap_cluster'
                color = '#000000'
            } else if(types.size == 1 && types.has(6)) { //only dumpster
                imgName = 'ic_qmarker_dumpster_cluster'
                color = '#4a9e34'
            } else if(types.size == 1 && types.has(7)) { //only handwash
                imgName = 'ic_qmarker_handwash_cluster'
                color = '#937902'
            } else if(types.size == 1 && types.has(8)) { //only tank
                imgName = 'ic_qmarker_tank_cluster'
                color = '#00065a'
            }
            if(hasIssue) {
                imgName += '_issue'
            }
            return {imgName: imgName, color: color}
        },
        createCluster(cluster, hasIssue, types) {
            let count = cluster.getChildCount()
            let imgNameData = this.getClusterImageName(cluster, hasIssue, types)
            let cacheName = `${imgNameData.imgName}_${count}`
            var icon = this.cache.clusters.get(cacheName)
            if(icon != null) {
                return icon
            }
            var img = require(`@/assets/icons/${imgNameData.imgName}.png`)
            icon = L.divIcon({ html: `
<div class="asset_marker_wrapper cluster">
<img class="asset_marker_img" src="${img}"/>
<div class="asset_marker_lbl" style="background: ${imgNameData.color}; border-color: ${imgNameData.color};">${count}</div>
</div>
`, iconAnchor: [17.5, 23],})
            this.cache.clusters.set(cacheName, icon)
            return icon;
            // return L.divIcon({ html: `<div class="no_votes_marker">Assets:&nbsp;${emptyItems}</div>` });
        },
        createClusterHtml(cluster) {
            var hasIssue = false
            let types = new Set()
            for (let markerIndex in cluster.getAllChildMarkers()) {
                let marker = cluster.getAllChildMarkers()[markerIndex]
                if(marker.options) {
                    types.add(marker.options.t)
                    if(marker.options.has_i == true) {
                        hasIssue = true
                    }
                }
            }
            return this.createCluster(cluster, hasIssue, types)
        },
        createHistoryClusterHtml(cluster) {
            var hasIssue = false
            let types = new Set()
            for (let markerIndex in cluster.getAllChildMarkers()) {
                let marker = cluster.getAllChildMarkers()[markerIndex]
                if(marker.options) {
                    types.add(marker.options.t)
                    if(marker.options.i != null && marker.options.i.fixed == false) {
                        hasIssue = true
                    }
                }
            }
            return this.createCluster(cluster, hasIssue, types)
        },

        getAutocompleteAddressCollection() {
            this.autocompleteAddressCollection = new Promise((resolve, reject) => {
                this.searchAddressAutocomplete({searchText: this.searchAddressQuery, isGeocode:true, isAnon:true})
                    .then((response) => {
                        let res = response.items
                        for (let i = 0; res.length > i; i++) {
                            let item = res[i]
                            item.toLowerCase = () => item.description.toLowerCase()
                            item.toString = () => item.description
                            item.isAddress = true
                        }
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },

        getSearchAutocompleteQuestions(search) {
            console.log(`getSearchAutocompleteQuestions: ${search}`)
            let result = this.originalItems.filter(item =>
                (item.a_id != '<>' && item.a_id.toLowerCase().includes(search.toLowerCase()))
                ||
                (item.p && item.p.toLowerCase().includes(search.toLowerCase()))
            )
            return result
        },

        onSearchTypeSelected(type) {
            this.showAssetsSearchBtn = false
            this.searchAddressQuery = ''
            this.autocompleteAddressCollection = []
            this.searchType = type
            if(this.searchType == 'asset_id') {
                this.autocompleteAddressCollection = new Promise((resolve, reject) => {
                    resolve([]);
                });
            } else {
                this.items = this.originalItems
            }
        },

        onClearSearchClick() {
            this.searchAddressQuery = ''
        },
        async onSearchAddressChanged() {
            console.log('onSearchAddressChanged')
            if(this.searchType == 'address') {
                this.getAutocompleteAddressCollection()
            } else {
                this.filterAssetsBySearch()
            }
        },

        filterAssetsBySearch() {
            this.showAssetsSearchBtn = this.searchAddressQuery.trim().length > 2 && this.originalItems.length > 200
            if(this.originalItems.length <= 200 || this.searchAddressQuery.trim() == '') {
                this.onSearchByAssetClick()
            }
        },

        onSearchByAssetClick() {
            this.showLoader(true)
            let thiz = this
            new Promise(function (resolve, reject) {
                setTimeout(()=>{
                    if(thiz.searchAddressQuery.trim() == '') {
                        thiz.items = thiz.originalItems
                    } else {
                        thiz.items = thiz.getSearchAutocompleteQuestions(thiz.searchAddressQuery)
                    }
                    var bounds = L.latLngBounds()
                    thiz.items.forEach((item) => {
                        bounds.extend(item.latlng)
                    })
                    resolve(bounds)
                }, 0)
            }).then((bounds) => {
                console.log(`before fitMapToBounds this.items.length:${this.items.length}`)
                if(this.items.length > 0) {
                    this.fitMapToBounds(bounds)
                } else {
                    this.reclusterItems()
                }
                this.showLoader(false)
            })

        },

        async onSearchAddressSelect(item) {
            console.log(`search item selected:`, item)
            if(!item.isAddress) {
                this.$refs.myMap.mapObject.setView([item.latlng.lat, item.latlng.lng], 16)
                return
            }
            let address = item
            this.searchAddressQuery = address.description
            this.setProgressBarTag({
                show: true,
                tag: 'load address'
            })
            const placeId = address.placeId
            try {
                let response = await this.geocodeGooglePlaceId({placeId: placeId, isAnon: true})
                let zoom = this.mapData.zoom < 12 ? 12 : this.mapData.zoom
                console.log(`set map from address: zoom: ${this.mapData.zoom} new zoom: ${zoom}`)
				this.$refs.myMap.mapObject.setView([response.latLng.lat, response.latLng.lng], zoom)
            } catch (e) {
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'load address'
                })
            }

        },
		returnToMain() {
			this.$router.go(-1)
		},

        onMyGeolocationClick() {
            this.geolocate({zoom: 18}, (lat, lng, zoom, accuracy) => {
                console.log(`geolocate result`)
                this.$refs.myMap.mapObject.setView([lat, lng], 12)
                // this.myLocation = {
                //     lat: lat,
                //     lng: lng,
                //     accuracy: accuracy,
                // }
            });
        },
        async copyContent(text) {
            try {
                await navigator.clipboard.writeText(text);
                console.log('Content copied to clipboard');
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        }
    }
}
</script>

<style>
.leaflet-control-attribution {
    display: none;
}
.leaflet-div-icon {
    background: none;
    border: none;
}
.cluster_block {
    border: 1px solid white;
    width: fit-content;
    padding: 6px;
    background: white;
    border-radius: 10px;
}
.cluster_inner {
    display: flex;
    flex-direction: row;
}
.cluster_wrapper {
    background: #FFFFFFD9;
    display: flex;
    flex-direction: column;
    width: fit-content;
    padding: 6px;
    border-radius: 10px;
}
.cluster_no_votes {
    font-size: 8px;
    margin-top: 4px;
}
.cluster_legend {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    justify-content: center;
    max-height: 30px;
    font-size: 8px;
}
.pie {
    width: 30px;
    background: #438348;
    border-radius: 50%;
}
.pie circle {
    fill: none;
    stroke: #438348;
    stroke-width: 32;
}
.no_votes_marker {
    background: #FFFFFFD9;
    display: flex;
    flex-direction: row;
    width: fit-content;
    padding: 6px;
    border-radius: 10px;
}
.leaflet-marker-icon {
    width: auto !important;
    height: auto !important;
}
.leaflet-container .leaflet-marker-icon .asset_marker_img {
    max-width: 35px !important;
}
.asset_marker_img {
    max-width: 35px !important;
}
.asset_marker_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.asset_marker_lbl {
    position: absolute;
    background: white;
    text-align: center;
    border: 1px solid #2D59A2;
    height: 18px;
    border-radius: 9px;
    white-space: nowrap;
    font-size: 11px;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    top: -18px;
    min-width: 40px;
    font-weight: 800;
    align-items: center;
}
.my_loc .asset_marker_lbl {
    bottom: -18px;
    border: 1px solid #D40000;
}
.cluster .asset_marker_lbl {
    bottom: -10px;
    background: #2D59A2;
    color: white;
}
.asset_marker_lbl.current {
    background: #2D59A2;
    color: white;
    border: 1px solid #ffffff;
}
.marker_popup {
    display: flex;
    flex-direction: column;
    align-items: start;
}
.marker_popup .marker_popup_btns {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-self: end;
}
.marker_popup .history_btn {
    cursor: pointer;
    color: #2D59A2;
    text-decoration: underline;
    align-self: end;
}
.marker_popup .history_btn:hover {
    color: #0f3168;
}
.marker_popup .copy_link_btn {
    cursor: pointer;
    color: #2D59A2;
    text-decoration: underline;
    align-self: end;
}
.marker_popup .copy_link_btn:hover {
    color: #0f3168;
}
.marker_popup .close_history_btn {
    cursor: pointer;
    color: #f16767;
    text-decoration: underline;
    align-self: end;
}
.marker_popup .close_history_btn:hover {
    color: #952c2c;
}
.marker_popup .fix_issue_btn {
    cursor: pointer;
    color: #f16767;
    text-decoration: underline;
    align-self: end;
}
.marker_popup .fix_issue_btn:hover {
    color: #952c2c;
}

@media screen and (max-width: 600px) {
    .questions-map-container .leaflet-control-container {
        margin-top: 78px;
        position: absolute;
    }
}
</style>

<style scoped>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.map {
    width: 100%;
    height: 100%;
    position: absolute;
}
.md-field {
	margin: 0 !important;
	padding-top: 0px !important;
}
.searchfield_wrapper .md-field {
    margin-top: -7px !important;
}
.md-field.md-has-value label {
	top: -2px;
}
.md-field.md-focused label {
	top: -2px;
}
.refresh-btn {
    cursor: pointer;
    color: #4A85CB;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-top: 15px;
    padding-right: 15px;
}
@media screen and (max-width: 600px) {
    .range {
        left: 10px;
        width: auto !important;
    }
    .history_mode_wrapper {
        margin-left: 41px;
    }
}
.range {
    align-items: stretch;
    position: absolute;
    top: 10px;
    width: 400px;
    z-index: 999;
    right: 10px;
    display: flex;
    flex-direction: column;
}
.search_wrapper {
    background: white;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 6px;
}
.history_mode_wrapper {
    margin-top: 8px;
    background: white;
    border-radius: 4px;
    padding: 10px;
    text-align: center;
}
.history_mode_wrapper .history-cancel {
    cursor: pointer;
    font-weight: 800;
    color: #f16767;
    text-decoration: underline;
}
.searchfield_wrapper {
    flex: 1;
}
.search_clear_btn {
    padding-right: 4px;
    padding-left: 4px;
    padding-bottom: 4px;
    padding-top: 4px;
    position: absolute;
    right: 10px;
    width: 32px;
    height: 32px;
    top: 8px;
    cursor: pointer;
}
.search_clear_btn:hover {
    background: rgba(222, 222, 222, 0.26);
}
.search_search_btn {
    padding-right: 8px;
    padding-left: 8px;
    padding-bottom: 6px;
    padding-top: 6px;
    position: absolute;
    right: 50px;
    top: 8px;
    cursor: pointer;
}
.search_search_btn:hover {
    background: rgba(222, 222, 222, 0.26);
}
.search_type_selector {
    margin-top: 4px;
    text-align: end;
    font-size: 14px;
    font-weight: 300;
    color: #989898;
}
.search_type_selector .search_type_item {
    font-weight: 800;
    text-decoration: underline;
    cursor: pointer;
    color: #4e4e4e;
}

.map-dashboard .address_wrapper {
    display: flex;
    align-items: center;
    margin-right: 16px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 4px;
}

.custom_date_selector .form-control {
    height: 36px;
}

.map-dashboard .dropdown-range {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 5px 16px 12px 0px;
    border-radius: 4px;
    margin-right: 16px;
}

.dropdown-range.dates {
    padding-top: 0;
    padding-bottom: 0;
}

.custom_date_selector {
    display: flex;
    flex-direction: row;
}

.custom_date_selector input {
    border-bottom: 1px solid black;
}

.custom_date_selector .hide-picker /deep/ .bootstrap-datetimepicker-widget {
    display: none !important;
}

.custom_date_selector .btn {
    width: auto;
    height: 20px;
    padding: 0;
    margin: auto;
}


.questions-map-container {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #F3F3F3;
    display: flex;
    flex-direction: column
}

.range h6 {
    color: #2F2F2F;
    font-family: 'Nunito';
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;
	margin-bottom: 0;
	margin-top: 6px;
}

.range .dropdown /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-weight: 700;
    position: relative;
    padding: 5px 50px 5px 0;
    margin-left: 0;
    font-size: 16px;
    font-family: 'Nunito';
}

.range /deep/ .dropdown-menu {
    width: auto !important;
}

.range .dropdown:before {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    content: " ";
    background: #3F405C;
    width: 100%;
    height: 1px;
}

.range .dropdown:after {
    content: '';
    height: 7px;
    width: 7px;
    transform: rotate(45deg);
    right: 10px;
    top: 10px;
    position: absolute;
    border-bottom: 2px solid black;
    border-right: 2px solid black;
}

.my_loc_btn {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 999;
    cursor: pointer;
}
.my_loc_btn img {
    width: 60px;
    height: auto;
}


</style>
